"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectPromoById = exports.selectSilentMediafileId = exports.selectUpcomingGenerationMeta = exports.selectUpcomingStreamTitle = exports.selectUpcomingStreamId = exports.selectCurrentStreamTitle = exports.selectCurrentStreamId = exports.selectGenerationFetchLocked = exports.selectLastLocalRotationId = exports.selectNextRegenerationShouldImmediatelySwitch = exports.selectCurrentGenerationPresent = exports.selectUpcomingGenerationMediafileIds = exports.selectUpcomingGenerationPresent = exports.selectCurrentGenerationSettings = exports.selectUpcomingGenerationSettings = exports.selectIsRegenerationInProgress = exports.selectIsRegenerationRequired = exports.selectLastGenerationSettingsFetch = exports.selectLastGenerationUpdate = exports.selectGenerationSettingsAreFetching = exports.selectCurrentGenerationId = exports.selectGenerationLastUpdatedOnBackend = exports.selectGenerationLastUpdateIsFetching = exports.selectGenerationIsFetching = void 0;
var point_1 = require("./point");
function selectGenerationIsFetching(state) {
    var _a, _b, _c;
    return (_c = (_b = (_a = state.generation) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.areSettingsFetching) !== null && _c !== void 0 ? _c : false;
}
exports.selectGenerationIsFetching = selectGenerationIsFetching;
function selectGenerationLastUpdateIsFetching(state) {
    var _a, _b, _c;
    return (_c = (_b = (_a = state.generation) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.isLastUpdateFetching) !== null && _c !== void 0 ? _c : false;
}
exports.selectGenerationLastUpdateIsFetching = selectGenerationLastUpdateIsFetching;
function selectGenerationLastUpdatedOnBackend(state) {
    var _a, _b;
    return (_b = (_a = state.generation) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lastBackendSettingsUpdate;
}
exports.selectGenerationLastUpdatedOnBackend = selectGenerationLastUpdatedOnBackend;
function selectCurrentGenerationId(state) {
    var _a, _b;
    return (_b = (_a = state.generation) === null || _a === void 0 ? void 0 : _a.currentSettings) === null || _b === void 0 ? void 0 : _b.stream.id;
}
exports.selectCurrentGenerationId = selectCurrentGenerationId;
function selectGenerationSettingsAreFetching(state) {
    return selectGenerationIsFetching(state) || selectGenerationLastUpdateIsFetching(state);
}
exports.selectGenerationSettingsAreFetching = selectGenerationSettingsAreFetching;
function selectLastGenerationUpdate(state) {
    var _a, _b;
    return (_b = (_a = state.generation) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lastBackendSettingsUpdate;
}
exports.selectLastGenerationUpdate = selectLastGenerationUpdate;
function selectLastGenerationSettingsFetch(state) {
    var _a, _b, _c;
    return (_c = (_b = (_a = state.generation) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lastLastUpdateFetch) !== null && _c !== void 0 ? _c : 0;
}
exports.selectLastGenerationSettingsFetch = selectLastGenerationSettingsFetch;
function selectIsRegenerationRequired(state) {
    var _a, _b, _c;
    return (_c = (_b = (_a = state.generation) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.regenerationRequired) !== null && _c !== void 0 ? _c : false;
}
exports.selectIsRegenerationRequired = selectIsRegenerationRequired;
function selectIsRegenerationInProgress(state) {
    var _a, _b;
    return (_b = (_a = state.generation.metadata) === null || _a === void 0 ? void 0 : _a.regenerationInProgress) !== null && _b !== void 0 ? _b : false;
}
exports.selectIsRegenerationInProgress = selectIsRegenerationInProgress;
function selectUpcomingGenerationSettings(state) {
    var _a;
    return (_a = state.generation) === null || _a === void 0 ? void 0 : _a.upcomingSettings;
}
exports.selectUpcomingGenerationSettings = selectUpcomingGenerationSettings;
function selectCurrentGenerationSettings(state) {
    var _a;
    return (_a = state.generation) === null || _a === void 0 ? void 0 : _a.currentSettings;
}
exports.selectCurrentGenerationSettings = selectCurrentGenerationSettings;
function selectUpcomingGenerationPresent(state) {
    return !!selectUpcomingGenerationSettings(state);
}
exports.selectUpcomingGenerationPresent = selectUpcomingGenerationPresent;
function selectUpcomingGenerationMediafileIds(state) {
    var _a, _b, _c;
    return (_c = (_b = (_a = selectUpcomingGenerationSettings(state)) === null || _a === void 0 ? void 0 : _a.totalMediafiles) === null || _b === void 0 ? void 0 : _b.map(function (mf) { return mf.id; })) !== null && _c !== void 0 ? _c : [];
}
exports.selectUpcomingGenerationMediafileIds = selectUpcomingGenerationMediafileIds;
function selectCurrentGenerationPresent(state) {
    return !!selectCurrentGenerationSettings(state);
}
exports.selectCurrentGenerationPresent = selectCurrentGenerationPresent;
function selectNextRegenerationShouldImmediatelySwitch(state) {
    var _a, _b;
    return (_b = (_a = state.generation.metadata) === null || _a === void 0 ? void 0 : _a.nextRegenerationImmediateSwitch) !== null && _b !== void 0 ? _b : false;
}
exports.selectNextRegenerationShouldImmediatelySwitch = selectNextRegenerationShouldImmediatelySwitch;
function selectLastLocalRotationId(state) {
    var _a, _b;
    return (_b = (_a = state.generation.metadata) === null || _a === void 0 ? void 0 : _a.lastLocalRotationId) !== null && _b !== void 0 ? _b : 1;
}
exports.selectLastLocalRotationId = selectLastLocalRotationId;
function selectGenerationFetchLocked(state) {
    var _a, _b;
    return (_b = (_a = state.generation.metadata) === null || _a === void 0 ? void 0 : _a.generationFetchLocked) !== null && _b !== void 0 ? _b : false;
}
exports.selectGenerationFetchLocked = selectGenerationFetchLocked;
function selectCurrentStreamId(state) {
    var _a, _b;
    return (_b = (_a = state.generation.currentSettings) === null || _a === void 0 ? void 0 : _a.streamMeta) === null || _b === void 0 ? void 0 : _b.id;
}
exports.selectCurrentStreamId = selectCurrentStreamId;
function selectCurrentStreamTitle(state) {
    var _a, _b;
    return (_b = (_a = state.generation.currentSettings) === null || _a === void 0 ? void 0 : _a.streamMeta) === null || _b === void 0 ? void 0 : _b.title;
}
exports.selectCurrentStreamTitle = selectCurrentStreamTitle;
function selectUpcomingStreamId(state) {
    var _a, _b;
    return (_b = (_a = state.generation.upcomingSettings) === null || _a === void 0 ? void 0 : _a.streamMeta) === null || _b === void 0 ? void 0 : _b.id;
}
exports.selectUpcomingStreamId = selectUpcomingStreamId;
function selectUpcomingStreamTitle(state) {
    var _a, _b;
    return (_b = (_a = state.generation.upcomingSettings) === null || _a === void 0 ? void 0 : _a.streamMeta) === null || _b === void 0 ? void 0 : _b.title;
}
exports.selectUpcomingStreamTitle = selectUpcomingStreamTitle;
function selectUpcomingGenerationMeta(state) {
    var _a;
    return (_a = state.generation.upcomingSettings) === null || _a === void 0 ? void 0 : _a.streamMeta;
}
exports.selectUpcomingGenerationMeta = selectUpcomingGenerationMeta;
function selectSilentMediafileId(state) {
    var _a, _b, _c;
    return ((_b = (_a = state.generation.currentSettings) === null || _a === void 0 ? void 0 : _a.silentMediafile.id) !== null && _b !== void 0 ? _b : (_c = state.generation.upcomingSettings) === null || _c === void 0 ? void 0 : _c.silentMediafile.id);
}
exports.selectSilentMediafileId = selectSilentMediafileId;
function selectPromoById(state, id) {
    var e_1, _a;
    var currentSettings = selectCurrentGenerationSettings(state);
    if (!currentSettings)
        return;
    var adCampaigns = currentSettings.adcampaigns;
    var streamId = Number((0, point_1.selectPointStreamId)(state));
    var _loop_1 = function (ad) {
        var promoAd = ad.promoad.find(function (promo) { return promo.id === id; });
        if (promoAd) {
            var promo = ad.promos.find(function (promoData) { return promoData.id == promoAd.promoId; });
            if (promo) {
                return { value: {
                        adCampaign: ad,
                        streamId: streamId,
                        promoAd: promoAd,
                        promo: promo,
                    } };
            }
        }
    };
    try {
        for (var adCampaigns_1 = __values(adCampaigns), adCampaigns_1_1 = adCampaigns_1.next(); !adCampaigns_1_1.done; adCampaigns_1_1 = adCampaigns_1.next()) {
            var ad = adCampaigns_1_1.value;
            var state_1 = _loop_1(ad);
            if (typeof state_1 === "object")
                return state_1.value;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (adCampaigns_1_1 && !adCampaigns_1_1.done && (_a = adCampaigns_1.return)) _a.call(adCampaigns_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return;
}
exports.selectPromoById = selectPromoById;
//# sourceMappingURL=generation.js.map